export function getEffectivePermissions(userPermissions, projectPermissions) {
  if (!userPermissions || !projectPermissions) return userPermissions

  return Object.keys(userPermissions).reduce(
    (acc, key) => ({
      ...acc,
      [key]:
        typeof userPermissions[key] === 'boolean' &&
        typeof projectPermissions[key] === 'boolean'
          ? userPermissions[key] && projectPermissions[key]
          : userPermissions[key],
    }),
    {}
  )
}
